<template>
<div>
    <div class="row">
        <div class="col-md-12">
            <base-crud :ref="'vehicle_brandsCrud'"  :crudName="$t('Vehicle Brands')" :newText="$t('Add')+' '+$t('New')"  :table="table" :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true" :enableView="false" :enableReset="false" :dataForm="dataForm">
            </base-crud>
        </div>
    </div>
</div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
    data: function () {
        return {
            table: "vehicle_brandsTable",
            showMessageImport: false,
            vehicle_brandsCrud: {},
            pages: [],
            url: "",
            columns: [
                "id",
                "name",
                "status",
                "actions",
            ],
            tableData: ["id", "name", 'status'],
            optionsOrigin: {
                filterByColumn: true,
                debounce: 1000,
                filterable: ["id","name", "status"],
                pagination: {
                    chunk: 10,
                    dropdown: false,
                    nav: "scroll"
                },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: this.$t('id'),
                    name: this.$t('Name'),
                    status: this.$t('Status'),
                    actions: this.$t('action'),
                },

                texts: {
                    filterBy: this.$t('Filter'),
                    defaultOption: this.$t('Select'),
                },
                listColumns: {
                  status: [
                    {id: 1, text: this.$t('Active')},
                    {id: 0, text: this.$t('Inactive')}
                  ]
                },
                templates: {
                    status: function (h, row, index) {
                        return row.status == 1 ?
                            this.$t('Active') :
                            this.$t('Inactive')
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};
                    let query = this.$parent.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["company"];

                    return axios.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "vehicle_brands",
            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    computed: {
        options() {
            const headings = {
                id: this.$t('id'),
                name: this.$t('Name'),
                status: this.$t('Status'),
                actions: this.$t('action'),
            }

            const texts = {
                filterBy: this.$t('Filter'),
                defaultOption: this.$t('Select'),
            }
            return {
                ...this.optionsOrigin,
                texts,
                headings,
            }

        }

    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            let fileImport = document.getElementById("fileImport");

            fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

            return fd;
        },
        query: function (query) {
            let columns = {
                id: "id",
                name: "name",
                status: "status"

            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
        openInput() {
            document.getElementById("fileImport").click();
        },
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}

.uploading-image {
    display: flex;
    border-radius: 10px;
    width: 100px;
    height: 100px;
}
</style>
